import styles from "../assets/styles/NavigationBar.module.css";
import "../assets/styles/styles.css";
import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Send, ArrowRight } from "lucide-react";
import { motion } from "framer-motion";

export default function Header() {
    const [openMenu, setOpenMenu] = useState(false);
    const [togglePosition, setTogglePosition] = useState("start");
    const positions = ["start", "middle", "end"];
    const [isFixed, setIsFixed] = useState(false);
    const name = process.env.REACT_APP_NAME;

    const handleToggle = () => {
        const currentIndex = positions.indexOf(togglePosition);
        const nextIndex =
            currentIndex >= positions.length - 1 ? 0 : currentIndex + 1;
        setTogglePosition(positions[nextIndex]);
    };

    useEffect(() => {
        const handleScroll = () => {
            if (window.scrollY > 130) {
                setIsFixed(true);
            } else {
                setIsFixed(false);
            }
        };

        window.addEventListener("scroll", handleScroll);
    }, []);

    return (
        <nav className={`${styles.nav} ${isFixed && styles.fixed} `}>
            <section>
                <button
                    onClick={() => setOpenMenu((prev) => !prev)}
                    className={openMenu && styles.active}
                >
                    <span></span>
                    <span></span>
                </button>
                {openMenu && <Menu handleClose={setOpenMenu}></Menu>}
{!isFixed && <Link className={styles.logo} to="/">{name}</Link>}
                
            </section>
            <section></section>
            <section>
<a
  href="https://calendly.com/orinomohamed/new-meeting"
  target="_blank"
  rel="noopener noreferrer"
  style={{
    padding: "12px 28px",
    borderRadius: "9999px", // smoother pill shape
    background: isFixed ? "linear-gradient(90deg, #2b213b, #4a3d61)" : "transparent",
    color: isFixed ? "#fff" : "#2b213b",
    border: isFixed ? "none" : "1px solid #2b213b",
    fontWeight: 500,
    fontSize: "14px",
    letterSpacing: "0.5px",
    cursor: "pointer",
    textDecoration: "none",
    display: "inline-flex",
    alignItems: "center",
    gap: "8px",
    boxShadow: isFixed
      ? "0 4px 12px rgba(0,0,0,0.15)"
      : "none",
    transition: "all 0.3s ease",
  }}
>
  <span>Book a Call</span>
  <ArrowRight size={14} color={isFixed ? "#fff" : "#2b213b"} />
</a>

            </section>
        </nav>
    );
}

function Menu({ handleClose }) {
    const email = process.env.REACT_APP_EMAIL;
    const phone = process.env.REACT_APP_PHONE;
    const location =process.env.REACT_LOCATION

    
    return (
        <div className={`${styles.menu} 'fade-in'`}>
            <section>
                <Link onClick={() => handleClose((prev) => !prev)} to="/">
                    <p>HOME</p>
                    <p>HOME</p>
                    <span>01</span>
                </Link>
                <Link
                    onClick={() => handleClose((prev) => !prev)}
                    to="/client-portal"
                >
                    <p>CLIENT PORTAL</p>
                    <p>CLIENT PORTAL</p>
                    <span>02</span>
                </Link>
            </section>
            <section>
                <section>
                    <h4>Get In Touch</h4>
                    <p>
                        {location}
                    </p>
                    <p>
                        Email: <a href={`mailto:${email}`}>{email}</a>
                    </p>
                    <p>Phone/WhatsApp: <a href={`tel:${phone}`}>{phone}</a></p>
                </section>
            </section>
        </div>
    );
}
